import escape from 'escape-html'

export default function adjustAname(element, bis) {
  //console.log("je lance le adjustAname");
  var finder = element.select("#anameandtitle" + bis);
  if (finder == null) {
    //console.log("no anameandtitle");
  } else {

    const rect = finder.select('rect');
    const aname = finder.select('#aname' + bis + ' text');
    const atitle = finder.select('#atitle' + bis + ' text');

    const align = escape(finder.attr('si:aalign'));

    const rW = rect.getBBox().w;
    const rX = rect.getBBox().x;
    let nW = aname.getBBox().width;
    let tW = atitle.getBBox().w;

    const aZone = (rW - tW) / 1.2;

    //console.log('rW : ' + rW + ' / rX : ' + rX + ' / nW : ' + nW + ' / tW : ' + tW + ' / aZone :' + aZone)

    // remove transform to put x and y
    if (aname.attr('x') === null) {
      aname.attr('y', Math.round(aname.transform().localMatrix.split().dy));
      aname.attr('x', Math.round(aname.transform().localMatrix.split().dx));
    }
    aname.node.removeAttribute('transform');
    //
    if (atitle.attr('x') === null) {
      atitle.attr('y', Math.round(atitle.transform().localMatrix.split().dy));
      atitle.attr('x', Math.round(atitle.transform().localMatrix.split().dx));
    }
    atitle.node.removeAttribute('transform');

    //verify size ratio and change fontsize

    if (nW > aZone) {

      aname.node.style.fontSize = '200px';
      nW = aname.getBBox().w;
      const ratio = nW / aZone
      aname.node.style.fontSize = `${200 / ratio}px`
      atitle.node.style.fontSize = `${(200 / ratio)/1.3}px`
      nW = aname.getBBox().w;
      tW = atitle.getBBox().w;
    }

    // place elements
    switch (align) {
      case 'center':
        var start = rX + Math.round((rW - nW - tW - (atitle.getBBox().h / 1.618)) / 2);
        aname.attr('x', start);
        //
        var startT = aname.getBBox().x + nW + atitle.getBBox().h;
        atitle.attr('x', startT);
        break;
      case 'left':
        aname.attr('x', rX);
        //
        var startT = rX + nW + atitle.getBBox().h;
        atitle.attr('x', startT);
        break;

      case 'right':
        var start = rX + rW - Math.round((nW + tW + (atitle.getBBox().h / 1.618)));
        aname.attr('x', start);
        //
        var startT = aname.getBBox().x + nW + atitle.getBBox().h;
        atitle.attr('x', startT);
        break;

      default:
        break;
    }
  }
}
